import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors, radii } from '../../theme/tokens';
import Reveal from './Reveal';
import { CallButton, GetQuoteButton } from './QuoteButtons';

type CtaPanelProps = {
  title: string;
  text: string;
  quoteLabel?: string;
};

const CtaPanel: React.FC<CtaPanelProps> = ({ title, text, quoteLabel }) => (
  <Reveal>
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        p: { xs: 4, md: 6 },
        borderRadius: radii.xl,
        border: `1px solid ${colors.border}`,
        background:
          'radial-gradient(120% 140% at 0% 0%, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0.02) 45%, rgba(255,255,255,0) 70%), #1a1a1a',
        display: 'grid',
        gap: 3,
        gridTemplateColumns: { xs: '1fr', md: '1.4fr 1fr' },
        alignItems: 'center',
      }}
    >
      <Box>
        <Typography component="h2" variant="h3" sx={{ color: colors.text, fontSize: { xs: '1.7rem', md: '2.2rem' } }}>
          {title}
        </Typography>
        <Typography sx={{ color: colors.textMuted, mt: 1.5, maxWidth: 560 }}>{text}</Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: 1.5,
          flexWrap: 'wrap',
          justifyContent: { xs: 'flex-start', md: 'flex-end' },
        }}
      >
        <GetQuoteButton label={quoteLabel} />
        <CallButton />
      </Box>
    </Box>
  </Reveal>
);

export default CtaPanel;
